import { render, staticRenderFns } from "./ReporteTrasabilidadDetalle.vue?vue&type=template&id=15a10e6e"
import script from "./ReporteTrasabilidadDetalle.vue?vue&type=script&lang=js"
export * from "./ReporteTrasabilidadDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports